import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import RuleForm from '../inputs/RuleForm';
import InlineRegionSelect from '../inputs/InlineRegionSelect';


const CredentialUnconnectedRule = (props) => {
  const {
    form, type, onSubmit, initialValues, ...other
  } = props;
  const [regions, setRegions] = useState(
    !_.isEmpty(initialValues.regions) ? initialValues.regions : [0]
  );

  const submit = (event) => {
    event.preventDefault();
    onSubmit({
      kind: 'credential_unconnected',
      regions: _.filter(regions),
      value: {}
    });
  };

  const onReset = () => {
    setRegions(
      !_.isEmpty(initialValues.regions) ? initialValues.regions : [0]
    );
  };


  return (
    <RuleForm
      {...other}
      onSubmit={submit}
      onReset={onReset}
      isSubmitting={form.is_submitting}
    >
      <InlineRegionSelect
        value={regions}
        onChange={setRegions}
      />
    </RuleForm>
  );
};

CredentialUnconnectedRule.defaultProps = {
  type: 'add',
  initialValues: {}
};

CredentialUnconnectedRule.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  type: PropTypes.string,
  initialValues: PropTypes.object,
};

export default CredentialUnconnectedRule;
